import { render, staticRenderFns } from "./BuyEggsPage.vue?vue&type=template&id=7ef8e556&scoped=true&"
import script from "./BuyEggsPage.vue?vue&type=script&lang=js&"
export * from "./BuyEggsPage.vue?vue&type=script&lang=js&"
import style0 from "./BuyEggsPage.vue?vue&type=style&index=0&id=7ef8e556&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ef8e556",
  null
  
)

export default component.exports